import { render, staticRenderFns } from "./Step04.vue?vue&type=template&id=00bcbc1e&scoped=true"
import script from "./Step04.vue?vue&type=script&lang=js"
export * from "./Step04.vue?vue&type=script&lang=js"
import style0 from "./Step04.vue?vue&type=style&index=0&id=00bcbc1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bcbc1e",
  null
  
)

export default component.exports